import { useCallback } from "react";

import clsx from "clsx";

import { ALLOWED_GENRES } from "@musicfy/contants/ModelFields";

interface IGenreFilterProps {
  genreFilters: string[];
  setGenreFilters: React.Dispatch<React.SetStateAction<string[]>>;
}

export const ALL_GENRES = "all";

const GENRE_FILTERS = [ALL_GENRES, ...ALLOWED_GENRES];

const GenreFilter = ({
  genreFilters,
  setGenreFilters,
}: IGenreFilterProps): JSX.Element => {
  const onGenreClick = useCallback(
    (genre: string) => {
      const isGenreInFilter = genreFilters.includes(genre.toLowerCase());
      const isAllGenre = genre.toLowerCase() === ALL_GENRES;

      if (isGenreInFilter) {
        if (isAllGenre) {
          return;
        }

        const isLastGenreInFilter = genreFilters.length === 1;

        isLastGenreInFilter
          ? setGenreFilters([ALL_GENRES])
          : setGenreFilters((prev) => {
              return prev.filter((g) => g !== genre.toLowerCase());
            });
      } else {
        if (isAllGenre) {
          setGenreFilters([ALL_GENRES]);
          return;
        }

        setGenreFilters((prev) => {
          return [...prev.filter((g) => g !== ALL_GENRES), genre.toLowerCase()];
        });
      }
    },
    [genreFilters, setGenreFilters]
  );

  return (
    <div className="flex flex-wrap items-center gap-4">
      {GENRE_FILTERS.map((genre) => {
        const isSelected = genreFilters.includes(genre.toLowerCase());

        return (
          <div
            aria-label={`${isSelected ? "Selected" : "Filter By"} ${genre}`}
            role="button"
            tabIndex={0}
            onClick={() => onGenreClick(genre)}
            key={genre}
            className={clsx(
              "py-[6px] px-6 rounded-full border border-solid transition-all cursor-pointer",
              {
                "border-pink-200/10 bg-gradient-to-br from-pink-200/50 to-pink-200":
                  isSelected,
                "border-white/10 bg-gradient-to-br from-white/5 to-white/5 xl:hover:border-pink-200/70":
                  !isSelected,
              }
            )}
          >
            <div className="capitalize text-12">{genre}</div>
          </div>
        );
      })}
    </div>
  );
};

export default GenreFilter;
